<template>
  <nav class="pagination" aria-label="pagination">
    <ul class="pagination__list">
      <!-- First page -->
      <li v-if="current > siblings + 1" class="pagination__item">
        <RouterLink :to="getUrl(1)" class="pagination__item__link h5">
          1
        </RouterLink>
      </li>
      <!-- ...-->
      <li v-if="current > siblings + 2" class="pagination__item">
        <span>...</span>
      </li>

      <!-- Previous pages -->
      <template v-for="item in siblings" :key="`previous-${item}`">
        <li v-if="current + (item - siblings - 1) > 0" class="pagination__item">
          <RouterLink
            :to="getUrl(current + (item - siblings - 1))"
            class="pagination__item__link h5"
          >
            {{ current + (item - siblings - 1) }}
          </RouterLink>
        </li>
      </template>

      <!-- Current page -->
      <li class="pagination__item">
        <RouterLink
          :to="getUrl(current)"
          class="pagination__item__link active h5"
          aria-current="page"
        >
          {{ current }}
        </RouterLink>
      </li>

      <!-- Next pages -->
      <template v-for="item in siblings" :key="`next-${item}`">
        <li v-if="current + item < total" class="pagination__item">
          <RouterLink
            :to="getUrl(current + item)"
            class="pagination__item__link h5"
          >
            {{ current + item }}
          </RouterLink>
        </li>
      </template>

      <li v-if="current < total - (siblings + 1)" class="pagination__item">
        <span>...</span>
      </li>
      <!-- Last page  -->
      <li v-if="current < total" class="pagination__item">
        <RouterLink :to="getUrl(total)" class="pagination__item__link h5">
          {{ total }}
        </RouterLink>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

// Props
const props = defineProps({
  total: {
    type: Number,
    required: true,
  },
  // current: {
  //   type: Number,
  //   required: false,
  //   default: 1,
  // },
  baseUrl: {
    type: String,
    required: true,
  },
  useQueryParam: {
    type: Boolean,
    required: false,
    default: true,
  },
})

const current = ref(1)

const siblings = 3
const getHero = ref()
const route = useRoute()

onMounted(() => {
  if (route.query.page) {
    current.value = Number(route.query.page)
  }
  getHero.value = document.querySelector('.white-papers')
})

// Methods
const getUrl = (number: number) => {
  let { baseUrl } = props
  const baseUrlPaged = `${baseUrl}?page=${number}`

  if (number === 1) {
    if (route.query.tag) {
      return `${baseUrl}?tag=${route.query.tag}`
    }

    if (route.query['tag[]']) {
      const tags = route.query['tag[]'] as string[]
      baseUrl = `${baseUrl}?`

      tags.forEach((tag: string, index: number) => {
        baseUrl += `tag%5B%5D=${encodeURIComponent(tag)}`
        if (index < tags.length - 1) {
          baseUrl += '&'
        }
      })
    }

    return baseUrl
  }

  if (route.query['tag[]'] && Array.isArray(route.query['tag[]'])) {
    console.log('sss', route.query['tag[]'].length)
    if (route.query['tag[]'].length === 1) {
      return `${baseUrlPaged}&tag=${route.query['tag[]']}`
    }

    const tags = route.query['tag[]'] as string[]
    let url = `${baseUrlPaged}&`

    tags.forEach((tag: string, index: number) => {
      url += `tag%5B%5D=${encodeURIComponent(tag)}`
      if (index < tags.length - 1) {
        url += '&'
      }
    })

    return url
  }

  if (route.query.tag) {
    return `${baseUrlPaged}&tag=${route.query.tag}`
  }

  return baseUrlPaged
}
</script>

<style lang="scss" scoped>
.pagination__list {
  @extend %list-nostyle;

  display: flex;
  justify-content: center;
  align-items: baseline;
  gap: 5px;
}

.pagination__item span {
  display: inline-block;
  padding: $spacing * 0.5 $spacing * 0.75;
}

.pagination__item__link {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.6rem;
  aspect-ratio: 1;
  color: $c-gray-60;
  font-size: 1.6rem;
  border-radius: 4px;
  transition: color 0.2s;

  &:hover,
  &:active,
  &:focus-visible,
  &.active {
    color: $c-white;
    background-color: $c-pink;
  }

  &.active {
    color: $c-white;
    background-color: $c-red;
  }
}
</style>
